export default "__VITE_ASSET__CMxeLD7$__ 640w, __VITE_ASSET__00X$OcS9__ 1024w, __VITE_ASSET__MBdo7Q4$__ 1536w";